import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vaata toodet

  <span style="color:#85c1dc;">**FI:**</span>
  Katso tarkemmin

  <span style="color:#85c1dc;">**RU:**</span>
  Посмотреть
*/
/* @__NO_SIDE_EFFECTS__ */
const m502 = msg(
  mf`Vaata toodet`,
  mf`Katso tarkemmin`,
  mf`Посмотреть`,
)

export { m502 as 'w.module.premium.button' }